<span
  [attr.data-testId]="dataTestId"
  [class]="getClass()"
>
  <span>{{getRemainingCharacters()}}</span>
  <span>/</span>
  <span>{{maxCharacters}}</span>
  <span> {{localizationKey("characterCounterCharactersRemaining") | localize}}</span>
</span>
